import React from "react";
import StatCircle from "../components/StatCircle";

export default ({ isActive }) => {
  return (
    <div className="component third-component" style={{zIndex: 1}}>
      {isActive && <StatCircle />}
    </div>
  );
};
